import React from "react";
// mui 5
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
// custom style
import { StyledCardActions, StyledIconButton } from "./styledComponents";
// custom context
import { useCart } from "../../context/CartContext";

function AddToCartButton({ pokemon }) {
  // custom context
  const { onAddToCart } = useCart();
  return (
    <StyledCardActions>
      <StyledIconButton
        aria-label="add to cart"
        test-id="add-to-cart"
        onClick={() => onAddToCart(pokemon)}
      >
        <AddShoppingCartIcon />
      </StyledIconButton>
    </StyledCardActions>
  );
}

export default AddToCartButton;
